import $ from 'jquery';

import '../node_modules/bootstrap/js/dist/collapse';
import '../node_modules/wolficons/sprite.svg';
import './lib/accordion';
import './lib/focus-within';
import './lib/manage-scrollbar';
import './lib/return-to-top';
import '../editor/blocks/tracking.js';
import './lib/wolf-alert';

import { NCST } from './src';

$( function() {
	NCST.init();
} );

export { NCST as default, ControllerComponent } from './src';
